<template>

    <div class="slider__wrapper" :class="(media.length == 1) ? 'centered' : ''" id="slider">

        <template v-if="current_slide.type == 'video_url'">
            <div class="featured__item__container">
                <iframe title="video" class="video" :src="current_slide.url"></iframe>

                <template v-if="this.items[current_slide_index - 1]">
                    <div class="navigation prev" @click="setCurrentSlide(this.current_slide_index - 1)">
                        <img src="/images/icons/left_white.webp" alt="prev">
                    </div>
                </template>

                <template v-if="this.items[current_slide_index + 1]">
                    <div class="navigation next" @click="setCurrentSlide(this.current_slide_index + 1)">
                        <img src="/images/icons/right_white.webp" alt="next">
                    </div>
                </template>
            </div>
        </template>
        <template v-else>
            <div class="featured__item__container"
                @click="viewImage"
                v-bind:style="{
                        backgroundImage: current_slide.url,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundColor: 'black',
                        backgroundPosition: 'center'
                }">

                <template v-if="this.items[current_slide_index - 1]">
                    <div class="navigation prev" @click="setCurrentSlide(this.current_slide_index - 1)">
                        <img class="navico" src="/images/icons/left_white.webp" alt="prev">
                    </div>
                </template>

                <template v-if="this.items[current_slide_index + 1]">
                    <div class="navigation next" @click="setCurrentSlide(this.current_slide_index + 1)">
                        <img class="navico" src="/images/icons/right_white.webp" alt="next">
                    </div>
                </template>
            </div>
        </template>

        <template v-if="media.length > 1">

            <div class="dots">
                <div v-for="item, index in items" class="dot" :class="(current_slide.id == item.id) ? 'selected' : ''" @click="setCurrentSlide(index)" :key="index"></div>
            </div>

        </template>

    </div>
</template>
<script>
    export default {
        data(){
            return {
                current_slide: {
                    type: null,
                    url : null,
                    uid: null,
                },
                current_slide_index: 0,
                items: []
            }
        },
        props: ['media', 'assetpath'],
        created(){

            this.items = this.media.slice(0);

            this.items.sort((a, b) => {
                return a.order - b.order;
            });

            this.setCurrentSlide(this.current_slide_index);

        },
        mounted(){},
        methods: {

            setCurrentSlide(index){
                this.current_slide.type = this.items[index].type;
                this.current_slide.id = this.items[index].id;
                if(this.current_slide.type == 'image'){
                    this.current_slide.url = "url('" + '/image/' + this.assetpath + '/' + this.items[index].path + "')";
                } else {
                    this.current_slide.url = this.items[index].path;
                }

                this.current_slide_index = index;
            },

            viewImage(e){
                if(!e.target.classList.contains('navigation') && !e.target.classList.contains('navico')){
                    this.$root.$refs.imageModal.showModal('/image/' + this.assetpath + '/' + this.items[this.current_slide_index].path);
                }
            },
        }
    }
</script>
<style lang="scss" scoped>

    .slider__wrapper{
        display: block;
        position: relative;

        width: 745px;
        // height: 600px;
        height: auto;
        // min-height: 470px;
        min-height: 500px;
        
        overflow-y: hidden;
        user-select: none;

        margin: auto;

        &.centered{
            // margin: auto;
            margin-top: 48px;
        }

        .featured__item__container {
            position: relative;
            overflow: hidden;
            // width: 100%;
            width: 742px;
            height: 443px;
            transition: all .3s ease;
            // background: black;

            margin-bottom: 20px;

            .navigation{
                position: absolute;
                width: 50px;
                height: 100%;
                transition: all 0.3s ease;

                cursor: pointer;
                
                &.prev{
                    left: 0;
                    
                    background: transparent;

                    &:hover{
                        background: rgba(0,0,0, 0.3);
                    }

                    img{
                        top: 50%;
                        left: 16px;
                        position: absolute;
                        transition: all 0.3s ease;

                        &:hover{
                            transform: scale(1.3);
                        }
                    }
                }

                &.next{
                    right: 0;

                    background: transparent;

                    &:hover{
                        background: rgba(0,0,0, 0.3);
                    }

                    img{
                        top: 50%;
                        right: 16px;
                        position: absolute;
                        transition: all 0.3s ease;

                        &:hover{
                            transform: scale(1.3);
                        }
                    }
                }
            }

            .video{
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                width: 100%;
                height: 100%;

                border: none;
                outline: none;
            }
        }


        .dots{
            display: flex;
            flex-direction: row;
            justify-content: center;
            margin: auto;

            .dot{
                opacity: 0.2;
                background: white;
                width: 9px;
                height: 9px;
                border-radius: 50%;
                margin: 0 8px;
                transition: all .3s ease;

                cursor: pointer;

                &.selected{
                    background: #ED1163;
                    opacity: 1;
                }
            }
        }


       

        .current__slide, .next__slide{
            width: 100%;
            width: 100%;
            height: 600px;

            transition: all .3s ease;
        }

        .slide__preview, .video__preview{
            // width: 180px;
            min-width: 180px;
            height: 110px;
            cursor: pointer;
            margin: 0 4px;
        }

        .video__preview{
            background: black;
            position: relative;

            img{
                display: block;
                width: 32px;
                height: 32px;
                margin: auto;
                padding-top: 40px;
            }
        }
    }

    @media screen and (max-width: 1440px) {
        .slider__wrapper {
            width: 500px;

            .featured__item__container{
                width: 500px;
            }
        }
    }

    @media screen and (max-width: 836px) {

        .slider__wrapper {
            width: 90vw;

            .featured__item__container{
                width: 100%;
            }
        }

    }

</style>